import { WhatsappLogo } from "@phosphor-icons/react";

export default function WhatsAppFloat({ number, message = "Ciao Oasi Bagni, vorrei informazioni per ristrutturare il mio bagno e capire se posso richiedere un sopralluogo gratuito." }) {
  if (!number) return null;
  const clean = number.replace(/[^\d]/g, "");
  if (!clean) return null;
  const url = `https://wa.me/${clean}?text=${encodeURIComponent(message)}`;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float"
      className="hidden sm:flex fixed bottom-5 left-5 z-40 items-center gap-2 bg-white border border-brand rounded-full pl-3 pr-5 py-2.5 shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5">
      <span className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center flex-shrink-0">
        <WhatsappLogo size={20} weight="fill" className="text-white" />
      </span>
      <span className="hidden sm:inline text-sm text-anthracite font-medium whitespace-nowrap">Scrivici su WhatsApp</span>
    </a>
  );
}
